// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const Unlock_Stroke2_Corner2_Rounded = createSinglePathSVG({
  path: 'M19.5 7.5H9V5.25a3 3 0 0 1 3-3c1.44 0 2.738 1.031 3.015 2.4a.75.75 0 0 0 1.47-.3C16.061 2.265 14.175.75 12 .75a4.505 4.505 0 0 0-4.5 4.5V7.5h-3A1.5 1.5 0 0 0 3 9v10.5A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.5-1.5V9a1.5 1.5 0 0 0-1.5-1.5Zm0 12h-15V9h15v10.5Zm-6.375-5.25A1.125 1.125 0 1 1 12 13.125a1.125 1.125 0 0 1 1.125 1.125Z',
  viewBox: '0 0 24 24',
  glyph: 'Unlock_Stroke2_Corner2_Rounded',
})
